<template>
  <v-dialog v-model="active" width="500" persistent>
    <v-card>
      <v-card-title> Cambiar estado </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-3 text-h6" v-if="payload">
        Seguro que quiere cambiar el estado del colaborador a
        {{ getEmployeeStatus(payload.form.status) }}?
        <br />

        <v-textarea
          label="Nota o observación"
          v-model="payload.form.note"
          v-if="addNote"
        ></v-textarea>

        <v-select
          :items="this.$store.state.charge.charges.charges"
          label="Cargo"
          v-model="payload.form.charge_id"
          v-if="addCharge"
          item-text="name"
          item-value="id"
        ></v-select>

        <v-select
          :items="this.$store.state.status.chargePermissions"
          v-model="payload.form.can_create_bill_without_report"
          :rules="[this.$store.state.rules.required]"
          v-if="addCharge"
          label="Puede Crear Cuenta De Cobro Sin Informe?"
          required
        ></v-select>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="cancel()"> Cancelar </v-btn>
        <v-btn color="primary" text @click="agree()"> Aceptar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SET_ALERT } from "@/store/alert";
import { mapGetters } from "vuex";
export default {
  name: "Cancel",
  props: {
    active: {
      required: true,
    },
    payload: {
      required: true,
    },
    addNote: {
      required: true,
    },
    addCharge: {
      required: true,
    },
  },
  computed: {
    ...mapGetters(["getEmployeeStatus"]),
  },
  created() {
    this.$store.dispatch("getChargesAll");
  },
  methods: {
    agree() {
      //validate if added the note
      if (this.addNote && !this.payload.form.note) {
        this.$store.commit(SET_ALERT, {
          message: "Debe agregar una nota",
          type: "error",
        });
        return;
      }
      //validate if added the charge
      if (
        this.addCharge &&
        !this.payload.form.charge_id &&
        !this.payload.form.can_create_bill_without_reportan
      ) {
        this.$store.commit(SET_ALERT, {
          message: "Debe agregar algun campo para actualizar",
          type: "error",
        });
        return;
      }
      this.$store.dispatch("editEmployee", this.payload);
      this.$emit("update:active", false);
    },
    cancel() {
      this.$emit("update:active", false);
    },
  },
};
</script>
